import ProjectBrief from 'project/containers/brief';
import ProjectWrapup from 'project/containers/wrapup';
import ProjectWrapupIntro from 'project/components/wrapup/intro';
import ProjectSettings from 'project/containers/project_settings';
import Invited from 'project/containers/invited';
import RemovedAccess from 'project/containers/removed';
import Participants from 'project/containers/participants';
import ProjectTour from 'project/containers/tour';

import { ApprovedAccess, PendingAccess, DeniedAccess } from 'project/containers/access_types';

export {
  ProjectBrief, ProjectWrapup, ProjectWrapupIntro, ProjectSettings, ApprovedAccess,
  PendingAccess, DeniedAccess, Participants, Invited, RemovedAccess, ProjectTour
};



// WEBPACK FOOTER //
// ./project/index.js